<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "StackBar",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "170px"
    },
    fontSize: {
      type: Number,
      default: 12
    },
    chartData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      chart: null,
      itemStyleList: [
        {
          normal: {
            color: {
              type: "linear",
              x: 1,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [
                {
                  offset: 0,
                  color: "#006adf"
                },
                {
                  offset: 1,
                  color: "#0ebcff"
                }
              ],
              globalCoord: false
            }
          }
        },
        {
          normal: {
            color: "#cbeeff"
          }
        },
        {
          normal: {
            color: "#59cbe5"
          }
        }
      ]
    };
  },
  mounted() {
    if (this.chartData) {
      this.initChart();
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.initChart();
    }
  },
  methods: {
    initChart() {
      let series = [];
      for (let i = 0; i < this.chartData.data.length; i++) {
        let temp = {
          name: this.chartData.data[i].legend,
          type: "bar",
          barWidth: 23,
          stack: "总量",
          itemStyle: this.itemStyleList[i],
          data: this.chartData.data[i].valueList
        };
        series.push(temp);
      }
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          icon: "rect",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#cbeeff"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "0%",
          top: "20%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: "0",
            textStyle: {
              color: "#cbeeff",
              fontSize: this.fontSize
            }
          },
          data: this.chartData.nameList
        },
        yAxis: {
          type: "value",
          name: "人数",
          nameTextStyle: {
            color: "#cbeeff"
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#cbeeff",
              fontSize: this.fontSize
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#414f5a",
              type: "dashed"
            }
          }
        },
        series: series
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<style scoped lang="less"></style>
